import React from 'react';
export default function WarningDialog() {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "You report is too big for sharing in one email, you will be able to share more items in separate emails"));
}